<template>
    <div :id="filterName + '-filter'">
        <template v-for="{value, isSelected} in filters">
            <span
                v-if="isSelected"
                class="badge"
            >
                {{ value }}
                <i
                    class="fas fa-times"
                    @click.prevent="provider.setFilter(filterName, value, false)"
                    style="cursor: pointer"
                ></i>
            </span>
        </template>
    </div>
</template>

<script setup lang="ts">

import {inject} from "vue";
import type JobApiProvider from "../JobApiProvider.ts";
import {KeyJobApiProvider} from "../symbols.ts";

interface PropsType {
    filterName: string
}

const props = defineProps<PropsType>();

const provider = inject<JobApiProvider>(KeyJobApiProvider) as JobApiProvider;

const filters = provider.filter(props.filterName);

</script>
